import API from '../api'
import postUrl from './paths'

export const moveOrderFilesWithinS3 = (fromDate, toDate, bodyObj) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.modeOrderFilesWithinS3, bodyObj, { fromDate, toDate })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
